import { ccclass, property, menu } from '../../../../core/data/class-decorator';
import { Component, Vec2, Size, v2, Node, director, Director } from '../../../../core';
import { Collider2D } from './collider-2d';
import { ECollider2DType } from '../../physics-types';
import { IPolygonShape } from '../../../spec/i-physics-shape';

@ccclass('cc.PolygonCollider2D')
@menu('Physics2D/Colliders/PolygonCollider2D')
export class PolygonCollider2D extends Collider2D {
    @property({ serializable: false, displayOrder: 0 })
    threshold = 1;

    @property
    private _points = [new Vec2(-1, -1), new Vec2(1, -1), new Vec2(1, 1), new Vec2(-1, 1)];

    private _worldPointsWithOffset: Vec2[] = [];
    private _isDirty: boolean = false;

    /**
     * @en Polygon points
     * @zh 多边形顶点数组
     */
    @property({ type: Vec2 })
    get points () {
        return this._points;
    }
    set points (v) {
        this._points = v;
    }

    /**
     * @en Get world points
     * @zh 世界坐标下多边形碰撞体的点
     */
    get worldPoints (): readonly Readonly<Vec2>[] {
        if (this._shape) {
            return (this._shape as IPolygonShape).worldPoints;
        }
        return [];
    }

    get worldPointsWithOffset (): readonly Readonly<Vec2>[] {
        if (this._isDirty) {
            this._updateWorldPointsWithOffset();
            this._isDirty = false;
        }
        return this._worldPointsWithOffset;
    }

    @property
    get offset (): Vec2 {
        return this._offset;
    }
    set offset (v: Vec2) {
        this._offset = v;
        this._updateWorldPointsWithOffset();
    }

    protected onLoad () {
        super.onLoad();
        director.on(Director.EVENT_BEFORE_DRAW, () => {
            if (!this._isDirty) {
                this._isDirty = !!this.node.hasChangedFlags;
            }
        }, this);
    }

    private _updateWorldPointsWithOffset () {
        this._worldPointsWithOffset.length = 0;
        this.worldPoints.forEach((point) => {
            this._worldPointsWithOffset.push(v2(point.x + this.offset.x, point.y + this.offset.y));
        });
    }

    readonly TYPE = ECollider2DType.POLYGON;
}
